export default __webpack_public_path__ + "static/media/secondary.27b6bd1c603fbfaa0c664460ac5b78f8.svg";